import { fontSize, maxBreakpoints, minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem, stack } from '@noths/polaris-client-styles';
import { css } from 'styled-components';
var spacing = theme.spacing,
  text = theme.text;
export var heading = /*#__PURE__*/css(["", " color:var(--neutral-black-base);margin:", ";"], fontSize(text.HEADING.MD), stack(spacing.md));
export var subHeading = /*#__PURE__*/css(["", " margin:", ";"], fontSize(text.HEADING.SM), stack(spacing.sm));
export var form = /*#__PURE__*/css(["padding:", " ", ";text-align:center;margin:0 auto;", ";", ";"], pxToRem(32), pxToRem(16), mediaQuery({
  max: maxBreakpoints.S
}, css(["max-width:", ";"], pxToRem(360))), mediaQuery({
  min: minBreakpoints.M
}, css(["max-width:", ";"], pxToRem(640))));
export var formButtons = /*#__PURE__*/css(["> div{margin:", ";}", ";", ";"], stack(spacing.md), mediaQuery({
  min: minBreakpoints.M
}, css(["display:flex;justify-content:space-between;align-items:flex-start;column-gap:", ";> div{flex-grow:1;}"], pxToRem(spacing.lg))), mediaQuery({
  min: minBreakpoints.XS,
  max: maxBreakpoints.XS
}, css(["max-width:", ";"], pxToRem(minBreakpoints.XS))));
export var privacyPolicy = /*#__PURE__*/css(["", " margin:", ";color:var(--neutral-black-base);"], fontSize(text.BODY.XS), stack(spacing.md));